import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export const IconUser = ({ className = '', ...rest }) => {
    return (
        <svg
            height="16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <path
                d="M6.488 8.404A3 3 0 015 5.813V3.544a3.001 3.001 0 016 0v2.269a3 3 0 01-1.488 2.591V9.2A4.502 4.502 0 0114 13.7v.3a1 1 0 01-1 1H3a1 1 0 01-1-1v-.3c0-2.48 2.01-4.494 4.488-4.5v-.796z"
                className={css.colored}
            />
        </svg>
    );
};
export default IconUser;
